const prefix = 'report-deleted-users';

const SET_USERS = `${prefix}/SET_USERS`;

const SET_LOADING = `${prefix}/SET_LOADING`;

const RESET = `${prefix}/RESET`;

export { SET_USERS, RESET, SET_LOADING };
